import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
// The publishable key (sb_publishable_…) on new projects; the older anon key still works locally.
const key = (import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || import.meta.env.VITE_SUPABASE_ANON_KEY) as string | undefined;

if (!url || !key) {
  throw new Error('VITE_SUPABASE_URL and VITE_SUPABASE_PUBLISHABLE_KEY must be set (see .env.example).');
}

const storageKey = 'one10-food-pass-auth';

// The sign-in is kept under one fixed name, so a browser that used this address with another project (staging moved
// to its own database, or localhost switched between local and --mode staging) would send that project's token here,
// which the API rejects ("No suitable key or wrong key type"). Forget the sign-in and cached passes when the project changes.
try {
  const owner = localStorage.getItem(`${storageKey}-project`);
  if (owner && owner !== url) {
    for (const k of [storageKey, `${storageKey}-code-verifier`, `${storageKey}-user`, 'one10:dashboard']) localStorage.removeItem(k);
  }
  localStorage.setItem(`${storageKey}-project`, url);
} catch {
  // Storage blocked: supabase-js keeps the session in memory.
}

export const supabaseUrl = url;
export const supabaseKey = key;

// PKCE: Google sends people back with a one-time code (exchanged here, with a secret this browser kept), not tokens
// in the address. Email codes work the same either way.
export const supabase = createClient(url, key, {
  auth: { persistSession: true, autoRefreshToken: true, storageKey, flowType: 'pkce', detectSessionInUrl: true },
});
